<template>
  <section class="home-hero" id="home-hero">
    <div
      class="home-hero__top"
      v-if="$tvaMq === 'tablet' || $tvaMq === 'mobile'"
    >
      <IntestationHero
        v-if="$tvaMq === 'mobile'"
        :title="title"
        :subtitle="subtitle"
        :noScroll="true"
      />

      <Framework class="home-hero__left" />

      <div class="home-hero__links">
        <p class="home-hero__links-title">{{ linkTitle }}</p>
        <LinkButton
          class="home-hero__links-link"
          v-for="link in links"
          :key="link.title"
          :label="link.title"
          :url="link.url"
          :iconAfter="external"
        />
      </div>
    </div>

    <div class="home-hero__right" v-if="$tvaMq !== 'mobile'">
      <IntestationHero
        :text="text"
        :title="title"
        :subtitle="subtitle"
        :download="download"
      />
    </div>

    <Framework
      class="home-hero__left"
      v-if="$tvaMq !== 'tablet' && $tvaMq !== 'mobile'"
    />

    <div
      class="home-hero__links"
      v-if="$tvaMq !== 'tablet' && $tvaMq !== 'mobile'"
    >
      <p class="home-hero__links-title">{{ linkTitle }}</p>
      <LinkButton
        class="home-hero__links-link"
        v-for="link in links"
        :key="link.title"
        :label="link.title"
        :url="link.url"
        :iconAfter="external"
        :componentTitle="linkTitle"
        componentType="home hero"
      />
    </div>
  </section>
</template>

<script setup>
import LinkButton from "../atoms/LinkButton.vue";
import IntestationHero from "../molecules/IntestationHero.vue";
import { external } from "@/assets/icons/icons.js";
import Framework from "./Framework.vue";
import useTvaMq from "@/plugins/tvaMq.js";

defineProps({
  title: String,
  subtitle: String,
  text: String,
  download: Object,
  linkTitle: String,
  links: Array,
});

const { $tvaMq } = useTvaMq();
</script>

<style lang="scss" scoped>
.home-hero {
  width: 100%;
  height: calc(var(--vh) * 100);
  background-color: var(--bg-dark);
  color: var(--color-white);
  position: relative;
  display: flex;


  @media (min-width: 1380px) {
    min-height: 750px;
  }

  &__top {
    position: relative;
    height: 100%;
    width: 100%;

    .mobile & {
      height: fit-content;
    }
  }

  &__right {
    height: 100%;
    max-width: toRem(300);

    .tablet &,
    .mobile & {
      max-width: unset;
      max-height: toRem(355);
      width: 100%;
      border-top: 0.5px solid var(--color-light-grey);
    }
  }

  &__left {
  }

  &__links {
    position: absolute;
    bottom: 2rem;
    right: toRem(32);
    text-align: end;
    color: var(--color-white);

    &-link:first-of-type {
      margin-bottom: toRem(10);
    }

    &-title {
      margin-bottom: toRem(12);
      @include dida-s;
    }

    .tablet &,
    .mobile & {
      bottom: toRem(24);
      right: toRem(32);

      .home-hero__links-link {
        align-items: flex-start;
      }
    }
  }

  .desktop &,
  .large & {
    padding-left: calc(var(--page-padding-h) + var(--page-padding-h-offset));
    width: var(--left-space);

    // padding: 1.5rem 2rem 1.5rem 3.5vw;
    align-items: flex-start;
  }

  .tablet &,
  .mobile & {
    color: var(--white-100);
    // background: linear-gradient(115.66deg, #025e6b 18.8%, #4fa1ad 84.48%);
    text-align: center;
    align-items: center;
    flex-direction: column;
    @media (max-height: 850px) {
      height: auto;
      &__top {
        height: 100vh !important;
      }
    }
    &__top {
      // min-height: 780px;
    }

    .home-content__right {
      &__logo {
        margin-bottom: toRem(15);
      }
    }
  }

  .mobile & {
    // padding: 3vh 1.5rem;
    .home-hero__top {
      height: 100%;
    }
  }
}
</style>
